import React from 'react';
import * as styles from './address.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Address = address => {
  var division = address.division,
    state = address.state,
    postcode = address.postcode;
  var formatFullAddress = addressModel => {
    var addressLine2 = [addressModel.division, addressModel.state, addressModel.postcode].filter(item => item).join(' ');
    var formattedAddress = [addressModel.street, addressLine2].filter(item => item).join(', ');
    return formattedAddress;
  };
  var renderAddressLine = () => {
    if (!(division || state || postcode)) {
      return false;
    }
    var addressLine = [];
    if (division) {
      addressLine.push(___EmotionJSX("span", {
        itemProp: "addressLocality",
        key: "locality"
      }, division));
    }
    if (state) {
      addressLine.push(___EmotionJSX("span", {
        itemProp: "addressRegion",
        key: "region"
      }, state));
    }
    if (postcode) {
      addressLine.push(___EmotionJSX("span", {
        itemProp: "postalCode",
        key: "postcode"
      }, postcode));
    }
    var line2Spaced = addressLine.reduce((prev, curr, index) => {
      if (index === 0) {
        prev.push(curr);
      } else {
        prev.push(' ');
        prev.push(curr);
      }
      return prev;
    }, []);
    return ___EmotionJSX("span", {
      css: styles.addressLine
    }, line2Spaced);
  };
  return ___EmotionJSX("div", {
    itemScope: true,
    itemProp: "location",
    itemType: "http://schema.org/Residence"
  }, ___EmotionJSX("meta", {
    itemProp: "name",
    content: formatFullAddress(address)
  }), ___EmotionJSX("h2", {
    itemProp: "address",
    itemScope: true,
    itemType: "http://schema.org/PostalAddress",
    css: styles.address
  }, renderAddressLine()));
};